import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { SimplebarAngularComponent, SimplebarAngularModule } from 'simplebar-angular';
import MetisMenu from 'metismenujs';
import { AsyncPipe, NgForOf, NgTemplateOutlet } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Observable } from 'rxjs';
import { CommonComponent } from '@components/common.component';
import { authenticationActions, selectAuthentication } from '@redux/authentication.redux';
import { Module } from '@models/common/module.model';

@Component({
  selector: 'app-side-bar',
  standalone: true,
  imports: [
    SimplebarAngularModule,
    NgTemplateOutlet,
    RouterLink,
    RouterLinkActive,
    NgForOf,
    AsyncPipe,
  ],
  templateUrl: './side-bar.component.html',
  styleUrl: './side-bar.component.scss',
})
export class SideBarComponent extends CommonComponent implements AfterViewInit {
  @ViewChild('simplebar') simplebar!: SimplebarAngularComponent;
  @ViewChild('sideMenu') sideMenu!: ElementRef;
  menu!: MetisMenu;

  protected modules$: Observable<Module[]> = this.store.select(selectAuthentication.selectModules);
  protected bottomModules$: Observable<Module[]> = this.store.select(
    selectAuthentication.selectBottomModules,
  );
  ngAfterViewInit(): void {
    this.menu = new MetisMenu(this.sideMenu.nativeElement);
  }

  logout() {
    this.store.dispatch(authenticationActions.logout({ communityCode: this.community?.code }));
  }
}
